import React, { ReactElement } from 'react';
import {
  Select as MuiSelect,
  MenuItem,
  TextField,
  StandardTextFieldProps,
  InputAdornment,
  SelectProps,
} from '@material-ui/core';
import { Control, Controller } from 'react-hook-form';
import useStyles from '../styles';

interface IIcon {
  position: 'left' | 'right';
  Component: ReactElement;
}

interface IOptions {
  id: string;
  label: string;
}

interface Iprops
  extends Omit<
    StandardTextFieldProps,
    'onChange' | 'value' | 'variant' | 'name'
  > {
  includeNone?: boolean;
  options: IOptions[];
  control: Control;
  rules: any;
  variant: 'standard' | 'outlined' | 'filled';
  icon?: IIcon;
  name: string;
  SelectProps?: Partial<SelectProps>;
}

export default function Select(props: Iprops) {
  const { control, rules, includeNone, options, icon, ...other } = props;
  const classes = useStyles();
  var defaultInputProps = {
    classes: {
      notchedOutline: classes.notchedOutline,
    },
  };

  return (
    <Controller
      render={({ onChange, value }) => (
        <TextField
          select
          value={value || ''}
          onChange={onChange}
          {...other}
          InputProps={{
            ...(defaultInputProps as any),
            ...other.InputProps,
            ...(icon &&
              icon.position === 'right' && {
                endAdornment: (
                  <InputAdornment position="end">
                    {icon.Component}
                  </InputAdornment>
                ),
              }),
            ...(icon &&
              icon.position === 'left' && {
                startAdornment: (
                  <InputAdornment position="start">
                    {icon.Component}
                  </InputAdornment>
                ),
              }),
          }}
        >
          {includeNone && <MenuItem value="">None</MenuItem>}
          {options.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.label}
            </MenuItem>
          ))}
        </TextField>
      )}
      name={other.name}
      control={control}
      rules={rules}
    />
  );
}
